import { useState, useEffect } from 'react';
import '../../../entrydoor.css';

const OverrideExtension = ({ value = { value: '', label: '' }, onChange, disabled = false, frameExtension }) => {
  const [selected, setSelected] = useState(value?.value || '');
  const [error,    setError]    = useState('');

  useEffect(() => { setSelected(value?.value || ''); }, [value?.value]);

  const handleChange = (e) => {
    const v = e.target.value;
    setSelected(v);
    validate(v);
    onChange({ value: v, label: v });
  };

  const validate = (v) => {
    // Override must not exceed the selected FrameExtension
    if (v && frameExtension?.value) {
      const overrideNum = parseFloat(v);
      const extNum      = parseFloat(frameExtension.value);
      if (!isNaN(overrideNum) && !isNaN(extNum) && overrideNum > extNum) {
        setError(`Override Extension must be ≤ ${frameExtension.value}`);
        return;
      }
    }
    setError('');
  };

  return (
    <div className="a-container">
      <label htmlFor="SdOverrideExtension">Override Extension</label>
      <input
        id="SdOverrideExtension"
        value={selected}
        onChange={handleChange}
        disabled={disabled}
        placeholder='e.g. 1"'
      />
      {error && <p className="error">{error}</p>}
    </div>
  );
};

export default OverrideExtension;
